import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";


export const shiperApi = createApi({
  reducerPath: "shiperApi",
  baseQuery,
  tagTypes: ["shipper"],

  endpoints: (builder) => ({    

    getCustomershipper: builder.query({
      query: ({ id }) => `/customer/shipper/${id}`,
    
      transformResponse: (response) => {
        const rows = Array.isArray(response?.data) ? response.data : [];
    
        // pick FIRST row (your form expects 1 record)
        const item = rows[0] || {};
    
        // normalize ID
        return {
          ...item,
          id: item.customerShipperId,
        };
      },
    
      providesTags: ["shipper"],
    }),    

    createShipper: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customer/shipper/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: { CustomerShipper: data },
      }),
      invalidatesTags: ["shipper"],
    }),

    updateShipper: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customer/shipper/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: { CustomerShipper: data },
      }),
      invalidatesTags: ["shipper"],
    }),

  }),
});

export const {
  useLazyGetCustomershipperQuery,
  useCreateShipperMutation,
  useUpdateShipperMutation,
} = shiperApi;
